export default (() => ({
    selectPaper: {
        maxWidth: 500
    }
}));
